"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapApiQueryStateToStatus = exports.QueryStatusError = exports.QueryStatusPending = exports.QueryStatusFinished = void 0;
exports.QueryStatusFinished = "finished";
exports.QueryStatusPending = "pending";
exports.QueryStatusError = "error";
function mapApiQueryStateToStatus(state) {
    switch (state) {
        case "QUERY_STATE_READY":
            return exports.QueryStatusPending;
        case "QUERY_STATE_RUNNING":
            return exports.QueryStatusPending;
        case "QUERY_STATE_STREAMING_RESULTS":
            return exports.QueryStatusPending;
        case "QUERY_STATE_FAILED":
            return exports.QueryStatusError;
        case "QUERY_STATE_CANCELED":
            return exports.QueryStatusError;
        case "QUERY_STATE_SUCCESS":
            return exports.QueryStatusFinished;
        default:
            throw new Error(`Unknown query state: ${state}`);
    }
}
exports.mapApiQueryStateToStatus = mapApiQueryStateToStatus;
//# sourceMappingURL=query-status.type.js.map